import React from "react";
import EmployeeForm from "./EmployeeForm";

export default function AddEmployee() {
  return <EmployeeForm type="Add" />;
}
